import InputText from '../components/Form/Fields/InputText';
import InputQuantity from '../components/Form/Fields/InputQuantity';
import Switcher from '../components/Form/Fields/Switcher';
import Select from '../components/Form/Fields/Select';
import ImprovedSelect from '../components/Form/Fields/ImprovedSelect';
import BarcodeComponent from '../components/BarcodeComponent';
import Table from '../components/Listing/Table';

import {
  faHome,
  faCubes,
  faPlug,
  faBookMedical,
  faStar,
  faBell,
  faRightLeft,
  faCoins,
  faGift,
  faMedal,
  faBarcode,
  faSlidersH,
  faComments,
  faClipboardList,
  faWandMagicSparkles,
} from '@fortawesome/free-solid-svg-icons';

const columns = [
  { Header: "Réglage",     Cell: (row) => <span>{row.feature}</span> },
  { Header: "Option",      accessor: "mode" },
  { Header: "Code-barres", Cell: (row) => <BarcodeComponent value={row.barcode} width={1} height={20} fontSize={10} /> },
  { Header: "Description", Cell: (row) => <span>{row.description}</span> },
];

// Every programming barcode from NETUM's "Wired 2D Scanner — Quick Setup Guide" (same code set
// as the NT-1228BL / 2D wired family). "(par défaut)" marks the factory setting (an asterisk in
// the manual). Only the Interleaved 2 of 5 "Any Length" option is left out: the guide prints
// its barcode without the code value.
const scannerHardwareConfig = [
  // Communication
  { feature: "Communication",          mode: "USB-KBW (par défaut)",        barcode: "3030011", description: "Connexion USB en mode clavier — plug & play, aucun pilote requis." },
  { feature: "Communication",          mode: "USB COM",                     barcode: "3030012", description: "Émulation d'un port série via USB (l'hôte reçoit les données comme sur un port COM)." },

  // Langue du clavier
  { feature: "Langue du clavier",      mode: "Américain (par défaut)",      barcode: "6060101", description: "Disposition clavier US (QWERTY)." },
  { feature: "Langue du clavier",      mode: "Français",                    barcode: "6060108", description: "Disposition clavier française (AZERTY)." },
  { feature: "Langue du clavier",      mode: "Belge",                       barcode: "6060102", description: "Disposition clavier belge (AZERTY)." },
  { feature: "Langue du clavier",      mode: "Allemand",                    barcode: "6060109", description: "Disposition clavier allemande (QWERTZ)." },
  { feature: "Langue du clavier",      mode: "Espagnol",                    barcode: "6060116", description: "Disposition clavier espagnole." },
  { feature: "Langue du clavier",      mode: "Portugais",                   barcode: "6060112", description: "Disposition clavier portugaise." },
  { feature: "Langue du clavier",      mode: "Italien",                     barcode: "606010D", description: "Disposition clavier italienne." },
  { feature: "Langue du clavier",      mode: "Anglais (UK)",                barcode: "606011B", description: "Disposition clavier britannique." },
  { feature: "Langue du clavier",      mode: "Turc Q",                      barcode: "606011A", description: "Disposition clavier turque Q." },
  { feature: "Langue du clavier",      mode: "Hongrois",                    barcode: "606010B", description: "Disposition clavier hongroise." },
  { feature: "Langue du clavier",      mode: "Tchèque",                     barcode: "606011D", description: "Disposition clavier tchèque." },
  { feature: "Langue du clavier",      mode: "Suédois",                     barcode: "6060117", description: "Disposition clavier suédoise." },

  // Mode de lecture
  { feature: "Mode de lecture",        mode: "Gâchette (par défaut)",       barcode: "2050220", description: "Appuyer sur le bouton pour lire, relâcher pour arrêter." },
  { feature: "Mode de lecture",        mode: "Continu",                     barcode: "2050204", description: "Lecture en continu : une nouvelle lecture se déclenche automatiquement après chaque code." },
  { feature: "Mode de lecture",        mode: "Détection automatique",       barcode: "2050209", description: "Le lecteur détecte un changement de luminosité (code présenté) et déclenche la lecture." },

  // Terminaison
  { feature: "Caractère de fin",       mode: "CR + LF (par défaut)",        barcode: "3030051", description: "Ajoute un retour chariot + saut de ligne (Entrée) après chaque code." },
  { feature: "Caractère de fin",       mode: "CR",                          barcode: "3030052", description: "Ajoute un retour chariot (Entrée) après chaque code." },
  { feature: "Caractère de fin",       mode: "TAB",                         barcode: "3030053", description: "Ajoute une tabulation après chaque code (passe au champ suivant)." },
  { feature: "Caractère de fin",       mode: "Aucun",                       barcode: "3030050", description: "N'ajoute aucun caractère après le code." },

  // Son
  { feature: "Volume du bip",          mode: "Fort (par défaut)",           barcode: "2050800", description: "Bip de lecture à volume élevé." },
  { feature: "Volume du bip",          mode: "Moyen",                       barcode: "2050801", description: "Bip de lecture à volume moyen." },
  { feature: "Volume du bip",          mode: "Faible",                      barcode: "2050802", description: "Bip de lecture à volume faible." },
  { feature: "Mode silencieux",        mode: "Désactivé (par défaut)",      barcode: "30300C0", description: "Les signaux sonores restent actifs." },
  { feature: "Mode silencieux",        mode: "Activé",                      barcode: "30300C1", description: "Coupe tous les signaux sonores." },

  // Réinitialisation
  { feature: "Réinitialisation",       mode: "Paramètres d'usine",          barcode: "303FFF3", description: "Annule toutes les configurations et restaure les réglages d'usine." },

  // Symbologies 1D
  { feature: "Add-on EAN/UPC",         mode: "Désactivé (par défaut)",      barcode: "2010E00", description: "Ignore le code complémentaire à 2 ou 5 chiffres des codes EAN/UPC." },
  { feature: "Add-on EAN/UPC",         mode: "Activé",                      barcode: "2010E02", description: "Lit le code complémentaire à 2 ou 5 chiffres des codes EAN/UPC." },
  { feature: "Interleaved 2 of 5",     mode: "Activé (par défaut)",         barcode: "1000061", description: "Active la lecture Interleaved 2 of 5 (14 chiffres par défaut)." },
  { feature: "Interleaved 2 of 5",     mode: "Désactivé",                   barcode: "1000060", description: "Désactive la lecture Interleaved 2 of 5." },
  { feature: "Codabar",                mode: "Activé",                      barcode: "1000071", description: "Active la lecture Codabar." },
  { feature: "Codabar",                mode: "Désactivé (par défaut)",      barcode: "1000070", description: "Désactive la lecture Codabar." },
  { feature: "MSI / MSI Plessey",      mode: "Activé",                      barcode: "1000141", description: "Active la lecture MSI." },
  { feature: "MSI / MSI Plessey",      mode: "Désactivé (par défaut)",      barcode: "1000140", description: "Désactive la lecture MSI." },
  { feature: "ISSN",                   mode: "Désactivé (par défaut)",      barcode: "3030330", description: "Désactive la lecture ISSN." },
  { feature: "ISSN",                   mode: "Activé",                      barcode: "3030331", description: "Active la lecture ISSN." },
  { feature: "GS1 DataBar-14",         mode: "Activé",                      barcode: "1000351", description: "Active la lecture GS1 DataBar-14 (RSS)." },
  { feature: "GS1 DataBar-14",         mode: "Désactivé (par défaut)",      barcode: "1000350", description: "Désactive la lecture GS1 DataBar-14." },
  { feature: "GS1 DataBar Limited",    mode: "Activé",                      barcode: "1000361", description: "Active la lecture GS1 DataBar Limited." },
  { feature: "GS1 DataBar Limited",    mode: "Désactivé (par défaut)",      barcode: "1000360", description: "Désactive la lecture GS1 DataBar Limited." },
  { feature: "GS1 DataBar Expanded",   mode: "Activé",                      barcode: "1000371", description: "Active la lecture GS1 DataBar Expanded." },
  { feature: "GS1 DataBar Expanded",   mode: "Désactivé (par défaut)",      barcode: "1000370", description: "Désactive la lecture GS1 DataBar Expanded." },
  { feature: "Codes 1D inversés",      mode: "Normal (par défaut)",         barcode: "3030910", description: "Lit les codes 1D classiques (barres noires sur fond blanc)." },
  { feature: "Codes 1D inversés",      mode: "Inversé",                     barcode: "3030911", description: "Lit les codes 1D inversés (barres blanches sur fond noir)." },

  // Symbologies 2D
  { feature: "PDF417",                 mode: "Activé (par défaut)",         barcode: "1000171", description: "Active la lecture PDF417." },
  { feature: "PDF417",                 mode: "Désactivé",                   barcode: "1000170", description: "Désactive la lecture PDF417." },
  { feature: "PDF417 inversé",         mode: "Normal (par défaut)",         barcode: "3030610", description: "Lit uniquement les PDF417 classiques." },
  { feature: "PDF417 inversé",         mode: "Normal et inversé",           barcode: "3030612", description: "Lit les PDF417 classiques et inversés." },
  { feature: "QR Code",                mode: "Activé (par défaut)",         barcode: "1003251", description: "Active la lecture des QR codes." },
  { feature: "QR Code",                mode: "Désactivé",                   barcode: "1003250", description: "Désactive la lecture des QR codes." },
  { feature: "QR Code inversé",        mode: "Normal (par défaut)",         barcode: "3030670", description: "Lit uniquement les QR codes classiques." },
  { feature: "QR Code inversé",        mode: "Normal et inversé",           barcode: "3030672", description: "Lit les QR codes classiques et inversés." },
  { feature: "Data Matrix",            mode: "Activé (par défaut)",         barcode: "1003241", description: "Active la lecture Data Matrix (utilisé sur les boîtes de médicaments)." },
  { feature: "Data Matrix",            mode: "Désactivé",                   barcode: "1003240", description: "Désactive la lecture Data Matrix." },
  { feature: "Data Matrix inversé",    mode: "Normal (par défaut)",         barcode: "30306B0", description: "Lit uniquement les Data Matrix classiques." },
  { feature: "Data Matrix inversé",    mode: "Normal et inversé",           barcode: "30306B2", description: "Lit les Data Matrix classiques et inversés." },
  { feature: "MaxiCode",               mode: "Activé",                      barcode: "1003261", description: "Active la lecture MaxiCode." },
  { feature: "MaxiCode",               mode: "Désactivé (par défaut)",      barcode: "1003260", description: "Désactive la lecture MaxiCode." },
  { feature: "Aztec",                  mode: "Activé",                      barcode: "1003281", description: "Active la lecture Aztec." },
  { feature: "Aztec",                  mode: "Désactivé",                   barcode: "1003280", description: "Désactive la lecture Aztec." },
];

const systemConfig = [
  // ─── 1. Général ──────────────────────────────────────────────────────────────
  {
    section: "general",
    id: "general",
    label: "Général",
    description: "Interface et préférences",
    icon: faHome,
    groups: [
      {
        id: "general_settings",
        label: "Interface",
        fields: [
          {
            id: "show_clock",
            label: "Afficher l'horloge dans la barre",
            type: Switcher,
            default: true,
          },
          {
            id: "collapse_header_on_scroll",
            label: "Masquer l'en-tête au défilement des listes",
            type: Switcher,
            default: false,
            helperMessage: "Masque automatiquement la barre de recherche et l'en-tête de page lorsque vous faites défiler une liste vers le bas.",
          },
          {
            id: "default_page",
            label: "Page par défaut après connexion",
            type: Select,
            options: [
              { value: '/dashboard',  label: 'Tableau de bord' },
              { value: '/products',   label: 'Produits' },
              { value: '/orders',     label: 'Ventes' },
              { value: '/invoices',   label: 'Factures' },
              { value: '/payments',   label: 'Paiements' },
              { value: '/patients',   label: 'Patients' },
              { value: '/confreres',  label: 'Confrères' },
              { value: '/suppliers',  label: 'Fournisseurs' },
            ],
            default: '/dashboard',
            helperMessage: "La page vers laquelle vous serez redirigé après chaque connexion.",
          },
          {
            id: "product_quick_view_enabled",
            label: "Activer l'aperçu rapide des produits",
            type: Switcher,
            default: false,
            helperMessage: "Si activé, cliquer sur un produit dans le listing ouvre un panneau d'aperçu rapide. Si désactivé, cliquer ouvre directement la fiche produit complète.",
          },
          {
            id: "virtual_keyboard_enabled",
            label: "Activer le clavier virtuel",
            type: Switcher,
            default: false,
            helperMessage: "Si activé, un clavier tactile s'affiche à l'écran lors de la saisie dans un champ texte. Utile sur un poste tout-en-un (écran tactile sans clavier physique).",
          },
        ],
      },
    ],
  },

  // ─── 2. Ventes ───────────────────────────────────────────────────────────────
  {
    section: "sales",
    id: "sales",
    label: "Ventes",
    description: "Panier et vente au comptoir",
    icon: faBookMedical,
    groups: [
      {
        id: "inventory",
        label: "Vente au comptoir",
        fields: [
          {
            id: "cart_auto_open",
            label: "Ouvrir le panier automatiquement lors d'un ajout",
            type: Switcher,
            default: true,
            helperMessage: "Si activé, le panneau panier s'ouvre à chaque ajout de produit.",
          },
          {
            id: "allow_out_of_stock_sales",
            label: "Autoriser la vente hors stock",
            type: Switcher,
            default: false,
            helperMessage: "Si activé, la vente est autorisée même sans stock disponible (stock négatif possible).",
          },
          {
            id: "require_patient_for_split_payment",
            label: "Exiger un patient pour un paiement par versements",
            type: Switcher,
            default: false,
            helperMessage: "Si activé, un patient doit obligatoirement être sélectionné pour valider une vente en paiement par versements.",
          },
          {
            id: "cart_merge_quantities",
            label: "Regrouper les articles identiques avec une quantité",
            type: Switcher,
            default: false,
            helperMessage: "Si activé, ajouter ou scanner un produit déjà présent dans le panier incrémente sa quantité au lieu de créer une nouvelle ligne. Si désactivé (comportement actuel), chaque ajout/scan crée une ligne distincte.",
          },
          {
            id: "cart_prioritize_oldest_batch",
            label: "Ajouter au panier le lot le plus ancien en priorité",
            type: Switcher,
            default: true,
            helperMessage: "Si activé, le lot dont la date d'expiration est la plus proche est sélectionné automatiquement lors de l'ajout au panier. Si désactivé, le lot le plus récent est sélectionné.",
          },
          {
            id: "cart_show_batch_selection",
            label: "Afficher le choix du lot dans le panier",
            type: Switcher,
            default: true,
            helperMessage: "Si activé, un produit ayant plusieurs lots disponibles affiche un sélecteur de lot dans le panier. Si désactivé, le lot est choisi automatiquement sans être affiché.",
          },
          {
            id: "product_list_dblclick_add_to_cart",
            label: "Ajouter au panier par double-clic dans le listing produits",
            type: Switcher,
            default: true,
            helperMessage: "Si activé, un double-clic sur un produit dans le listing des produits l'ajoute directement au panier.",
          },
        ],
      },
      {
        id: "currency",
        label: "Taux de change",
        icon: faRightLeft,
        fields: [
          {
            id: "provider",
            label: "API de conversion",
            type: Select,
            options: [
              { value: 'open_er_api', label: 'ExchangeRate-API (open.er-api.com)' },
              { value: 'fawazahmed0', label: 'Currency API (fawazahmed0)' },
            ],
            default: 'open_er_api',
            helperMessage: "Fournisseur utilisé pour convertir automatiquement en DH un paiement en espèces reçu en devise étrangère dans le panier.",
          },
        ],
      },
    ],
  },

  // ─── 3. Stock ────────────────────────────────────────────────────────────────
  {
    section: "stock",
    id: "stock",
    label: "Stock",
    description: "Alertes et échanges",
    icon: faCubes,
    groups: [
      {
        id: "inventory",
        label: "Alertes de stock",
        icon: faBell,
        fields: [
          {
            id: "min_stock_alert",
            label: "Seuil d'alerte de stock",
            type: InputQuantity,
            default: 10,
            validation: { min: 0 },
            helperMessage: "En dessous de ce seuil, un produit est marqué comme stock faible.",
          },
          {
            id: "max_stock_alert",
            label: "Seuil de stock max",
            type: InputQuantity,
            default: 0,
            validation: { min: 0 },
            helperMessage: "Au-delà de ce seuil, un produit est considéré en surstock. Laissez à 0 pour ne pas définir de seuil par défaut (un seuil peut toujours être défini produit par produit).",
          },
          {
            id: "expiration_warning_days",
            label: "Jours avant expiration (alerte)",
            type: InputQuantity,
            default: 90,
            validation: { min: 1 },
            helperMessage: "Nombre de jours avant la date d'expiration pour déclencher l'alerte.",
          },
        ],
      },
      {
        id: "exchanges",
        label: "Échanges entre pharmacies",
        icon: faRightLeft,
        fields: [
          {
            id: "allow_out_of_stock_exchange",
            label: "Autoriser l'envoi de produits hors stock",
            type: Switcher,
            default: false,
            helperMessage: "Si activé, l'envoi de produits vers une autre pharmacie est autorisé même sans stock disponible (stock négatif possible).",
          },
          {
            id: "prioritize_oldest_batch",
            label: "Envoyer en priorité le lot le plus ancien",
            type: Switcher,
            default: true,
            helperMessage: "Si activé, le lot dont la date d'expiration est la plus proche est envoyé en premier (FIFO). Si désactivé, le lot le plus récent est envoyé en premier.",
          },
        ],
      },
    ],
  },

  // ─── 4. Inventaire ───────────────────────────────────────────────────────────
  {
    section: "inventaire",
    id: "inventaire",
    label: "Inventaire",
    description: "Inventaire tournant automatique",
    icon: faClipboardList,
    groups: [
      {
        id: "general",
        label: "Inventaire Tournant",
        fields: [
          {
            id: "tournant_enabled",
            label: "Activer l'inventaire tournant automatique",
            type: Switcher,
            default: false,
            helperMessage: "Génère automatiquement un inventaire chaque semaine pour une sélection de produits prioritaires.",
          },
          {
            id: "tournant_limit",
            label: "Nombre de produits par session",
            type: InputQuantity,
            default: 50,
            validation: { min: 10, max: 500 },
            depends: { field: 'inventaire_general_tournant_enabled', value: true },
            helperMessage: "Nombre de produits sélectionnés pour chaque inventaire tournant hebdomadaire.",
          },
          {
            id: "batch_number_hidden_by_default",
            label: "Masquer le N° de lot par défaut",
            type: Switcher,
            default: true,
            helperMessage: "Si activé, le champ N° de lot est masqué par défaut lors du comptage d'un inventaire — il faut cliquer sur \"Afficher le N° de lot\" pour le saisir ou le consulter.",
          },
        ],
      },
    ],
  },

  // ─── 5. Fidélité ─────────────────────────────────────────────────────────────
  {
    section: "loyalty",
    id: "loyalty",
    label: "Fidélité",
    description: "Programme de points",
    icon: faStar,
    groups: [
      {
        id: "general",
        label: "Programme de fidélité",
        icon: faStar,
        fields: [
          {
            id: "enabled",
            label: "Activer le programme de fidélité",
            type: Switcher,
            default: false,
            helperMessage: "Permet aux clients de cumuler et d'utiliser des points de fidélité sur leurs achats.",
          },
        ],
      },
      {
        id: "earn",
        label: "Gagner des points",
        icon: faCoins,
        depends: { field: 'loyalty_general_enabled', value: true },
        fields: [
          {
            id: "points",
            label: "Points gagnés",
            type: InputQuantity,
            default: 10,
            validation: { min: 1 },
            helperMessage: "Nombre de points crédités au client pour chaque tranche de montant définie ci-dessous.",
          },
          {
            id: "per",
            label: "Par tranche de (dhs)",
            type: InputQuantity,
            default: 100,
            validation: { min: 1 },
            helperMessage: "Montant en dirhams nécessaire pour gagner les points définis ci-dessus. Ex : 10 points par tranche de 100 dhs.",
          },
        ],
      },
      {
        id: "redeem",
        label: "Dépenser des points",
        icon: faGift,
        depends: { field: 'loyalty_general_enabled', value: true },
        fields: [
          {
            id: "ratio",
            label: "Valeur d'un point (dhs)",
            type: InputText,
            default: 0.10,
            helperMessage: "Valeur en dirhams d'un point lorsqu'un client l'utilise en réduction sur un achat.",
          },
        ],
      },
      {
        id: "tiers",
        label: "Niveaux de fidélité",
        icon: faMedal,
        depends: { field: 'loyalty_general_enabled', value: true },
        fields: [
          {
            id: "silver",
            label: "Seuil Argent (points)",
            type: InputQuantity,
            default: 500,
            validation: { min: 0 },
            helperMessage: "Nombre de points cumulés à partir duquel un client atteint le niveau Argent.",
          },
          {
            id: "gold",
            label: "Seuil Or (points)",
            type: InputQuantity,
            default: 2000,
            validation: { min: 0 },
            helperMessage: "Nombre de points cumulés à partir duquel un client atteint le niveau Or.",
          },
        ],
      },
    ],
  },

  // ─── 6. Communication ────────────────────────────────────────────────────────
  {
    section: "communication",
    id: "communication",
    label: "Communication",
    description: "Notifications et canaux",
    icon: faComments,
    groups: [
      {
        id: "general",
        label: "Notifications",
        icon: faBell,
        fields: [
          {
            id: "enabled",
            label: "Activer les notifications",
            type: Switcher,
            default: true,
            helperMessage: "Active ou désactive l'envoi de notifications (alertes stock, rappels, ventes, etc.).",
          },
          {
            id: "channels",
            label: "Canaux de notification",
            type: ImprovedSelect,
            multiple: true,
            placeholder: "Choisir un ou plusieurs canaux...",
            options: [
              { value: 'EMAIL', label: 'Email' },
              { value: 'MOBILE_APP', label: 'Application mobile' },
            ],
            default: ['EMAIL', 'MOBILE_APP'],
            depends: { field: 'communication_general_enabled', value: true },
            helperMessage: "Choisissez les canaux par lesquels vous souhaitez recevoir les notifications.",
          },
        ],
      },
    ],
  },

  // ─── 7. Matériel ─────────────────────────────────────────────────────────────
  {
    section: "drivers",
    id: "drivers",
    label: "Matériel",
    description: "Scanners et périphériques",
    icon: faPlug,
    groups: [
      {
        id: "barcode_scanner",
        label: "Scanner code-barres",
        icon: faBarcode,
        fields: [
          {
            id: "enable_barcode_scanner",
            label: "Activer le scanner USB/Bluetooth",
            type: Switcher,
            default: true,
          },
          {
            id: "barcode_scanner_hardware",
            label: "Modèle de scanner",
            type: Select,
            options: [
              { value: 'netum',  label: "NETUM Barcode Scanner" },
              // WDLink (wdlinkma.com) only publishes datasheets, not programming guides — no
              // configuration barcodes until the setting codes for the actual model are known.
              { value: 'wdlink', label: "WDLink WD9500 (scanner de comptoir 2D)" },
            ],
            default: 'netum',
            depends: { field: 'drivers_barcode_scanner_enable_barcode_scanner', value: true },
          },
        ],
        groups: [
          {
            id: "inter",
            label: "Configuration NETUM",
            icon: faSlidersH,
            depends: { field: 'drivers_barcode_scanner_barcode_scanner_hardware', value: 'netum' },
            fields: [
              {
                id: "interenable_camera_scanner",
                Cell: () => (
                  // All rows at once: client-side "pagination" loads more on scrolling the table's
                  // own container, but here the table isn't height-bound — the settings page
                  // scrolls instead, so that never fired and only the first 10 codes showed.
                  <Table
                    columns={columns}
                    data={scannerHardwareConfig}
                    totalElements={scannerHardwareConfig.length}
                    pageSize={scannerHardwareConfig.length}
                  />
                ),
                default: true,
              },
            ],
          },
          {
            id: "wdlink",
            label: "WDLink WD9500",
            icon: faSlidersH,
            depends: { field: 'drivers_barcode_scanner_barcode_scanner_hardware', value: 'wdlink' },
            fields: [
              {
                id: "wdlink_info",
                // From WDLink's official WD9500 datasheet — it ships no programming barcodes, so
                // this is setup guidance rather than a configuration table like NETUM's.
                Cell: () => (
                  <div style={{ fontSize: 14, lineHeight: 1.6, color: '#374151', padding: '4px 8px' }}>
                    <ul style={{ paddingInlineStart: 18, marginBottom: 12 }}>
                      <li><strong>Branchement :</strong> USB, plug &amp; play — aucun pilote ni logiciel à installer (Windows, macOS, Linux).</li>
                      <li><strong>Lecture :</strong> mains libres, détection automatique — posez-le sur le comptoir et présentez le code devant la fenêtre, dans n'importe quel sens (360°).</li>
                      <li><strong>Volume du bip :</strong> se règle avec le bouton tactile sur le lecteur.</li>
                      <li><strong>Codes lus :</strong> 1D (EAN-13, EAN-8, UPC, Code 128, Code 39, Code 32 pharmaceutique…) et 2D (QR Code, Data Matrix, PDF417, Aztec…).</li>
                    </ul>
                    <p style={{ margin: 0, color: '#6b7280', fontSize: 13 }}>
                      WDLink ne publie pas de guide de programmation pour ce modèle. Pour modifier un réglage
                      (langue du clavier, caractère de fin…), utilisez le guide papier fourni avec le lecteur ou
                      contactez WDLink : <a href="mailto:info@wdlinkma.com">info@wdlinkma.com</a> · +212 660-790342.
                    </p>
                  </div>
                ),
              },
            ],
          },
        ],
      },
    ],
  },

  // ─── Saydalani AI ────────────────────────────────────────────────────────────
  // Stored as "ai_assistant_enabled" — read by the assistant (Assistant.js, Sidebar.js) and
  // enforced server-side (AssistantController / AssistantVoiceController).
  {
    section: "ai",
    id: "ai",
    label: "Saydalani AI",
    description: "Assistant intelligent",
    icon: faWandMagicSparkles,
    groups: [
      {
        id: "assistant",
        label: "Assistant",
        fields: [
          {
            id: "enabled",
            label: "Activer Saydalani AI",
            type: Switcher,
            default: true,
            helperMessage: "Affiche l'assistant intelligent : questions sur le stock, les ventes et les patients, création de produits et conversation vocale. Si désactivé, l'assistant est masqué pour tous les utilisateurs de la pharmacie.",
          },
          {
            // "ai_assistant_voice" — the Piper voice the voice service speaks with (VOICES in
            // voice-service/app.py)
            id: "voice",
            label: "Voix de l'assistant",
            type: Select,
            options: [
              { value: 'siwis',   label: 'Siwis — voix féminine' },
              { value: 'jessica', label: 'Jessica — voix féminine' },
              { value: 'camille', label: 'Camille — voix féminine' },
              { value: 'claire',  label: 'Claire — voix féminine' },
              { value: 'julie',   label: 'Julie — voix féminine' },
              { value: 'lea',     label: 'Léa — voix féminine' },
              { value: 'sophie',  label: 'Sophie — voix féminine' },
              { value: 'ines',    label: 'Inès — voix féminine' },
              { value: 'pierre',  label: 'Pierre — voix masculine' },
              { value: 'tom',     label: 'Tom — voix masculine' },
              { value: 'hugo',    label: 'Hugo — voix masculine' },
              { value: 'louis',   label: 'Louis — voix masculine' },
              { value: 'karim',   label: 'Karim — voix masculine' },
              { value: 'antoine', label: 'Antoine — voix masculine' },
              { value: 'yanis',   label: 'Yanis — voix masculine' },
              { value: 'marc',    label: 'Marc — voix masculine' },
            ],
            default: 'siwis',
            depends: { field: 'ai_assistant_enabled', value: true },
            helperMessage: "La voix utilisée quand l'assistant répond à voix haute, en conversation vocale.",
          },
        ],
      },
    ],
  },
];

export default systemConfig;
